import React, { useContext } from 'react';

/* packages */
import Fetch from '../../../util-fetch';
/* packages */

/* stores */
import ApproveStore from './store';
/* stores */

const Index = ({CONFIG, token}) => {
  const orderApproveContext  = useContext(ApproveStore);
  const orderApproveMethod = async (orderId) => {
    orderApproveContext.setLoading(true);
    CONFIG.application.approval.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.approval.api.endpoints.create.url + orderId + "/approve",
      config: {
        method: CONFIG.application.approval.api.endpoints.create.method,
        headers: CONFIG.application.approval.api.headers,
      }
    });
    orderApproveContext.setStatus(fetch[0]);
    orderApproveContext.setData(fetch[1]);
    orderApproveContext.setLoading(false);
  }
  const orderApproveData = orderApproveContext.isData();

  return { orderApproveContext, orderApproveMethod, orderApproveData }
}

export default Index;
